var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMicrophoneWhite = function SvgIconMicrophoneWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.6176 13.379C20.6176 12.9691 20.2852 12.6367 19.8751 12.6367C19.4651 12.6367 19.1327 12.9691 19.1327 13.379C19.1327 17.0105 16.1785 19.9647 12.547 19.9647C8.91566 19.9647 5.96145 17.0105 5.96145 13.379C5.96145 12.9691 5.62907 12.6367 5.21901 12.6367C4.80894 12.6367 4.47656 12.9691 4.47656 13.379C4.47656 17.5789 7.70123 21.0389 11.8045 21.415V23.4136H9.04937C8.63931 23.4136 8.30693 23.746 8.30693 24.1561C8.30693 24.5661 8.63931 24.8985 9.04937 24.8985H16.0448C16.4546 24.8985 16.787 24.5661 16.787 24.1561C16.787 23.746 16.4546 23.4136 16.0448 23.4136H13.2894V21.415C17.3929 21.0391 20.6176 17.5789 20.6176 13.379Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5485 18.1329C15.1698 18.1329 17.3024 16.0004 17.3024 13.3791V4.75753C17.3024 2.13646 15.1698 0.00390625 12.5485 0.00390625C9.92748 0.00390625 7.79492 2.13646 7.79492 4.75753V13.3791C7.79492 16.0004 9.92748 18.1329 12.5485 18.1329Z",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMicrophoneWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-microphone-white.22139354.svg";
export { ForwardRef as ReactComponent };